import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";

/**
 * Liten klocka i Dashboard-headern med en badge för olästa pushar.
 * Polling var 60:e sek + på mount. Klick → /meddelanden.
 */
export function NotificationsBell() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const { data } = await api.get("/notifications/unread-count");
        if (!cancelled) setCount(data?.unread_count || 0);
      } catch { /* tyst */ }
    };
    load();
    const t = setInterval(load, 60_000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  return (
    <Link
      to="/meddelanden"
      className="p-2 rounded-full hover:bg-[color:var(--bg-elevated)] text-[color:var(--text-secondary)] relative"
      data-testid="notifications-bell"
      title="Meddelanden"
    >
      <Bell size={18} />
      {count > 0 && (
        <span
          className="absolute -top-0.5 -right-0.5 min-w-[16px] h-[16px] px-1 rounded-full bg-[color:var(--jarvis)] text-white text-[9px] font-bold flex items-center justify-center"
          data-testid="notifications-bell-badge"
        >
          {count > 99 ? "99+" : count}
        </span>
      )}
    </Link>
  );
}
